import { useState, useEffect } from 'react';

const useQueryReview = (
  isOpen: boolean,
  onClose: () => void,
  onApprove: () => Promise<void> | void
) => {
  const [acknowledged, setAcknowledged] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setAcknowledged(false);
    }
  }, [isOpen]);

  const handleApprove = async () => {
    onClose();
    await onApprove();
  };

  return {
    acknowledged,
    setAcknowledged,
    handleApprove,
  };
};

export default useQueryReview;
